export default function Card({ 
  children, 
  className = "", 
  padding = "p-4",
  onClick,
  hover = false 
}) {
  const baseClasses = "bg-white rounded-2xl shadow-lg"
  const hoverClasses = hover ? "hover:shadow-xl transition-all duration-200 transform hover:-translate-y-1" : ""
  const clickableClasses = onClick ? "cursor-pointer touch-manipulation" : ""
  
  return (
    <div 
      className={`${baseClasses} ${hoverClasses} ${clickableClasses} ${padding} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
